module.exports = __webpack_public_path__ + "b880c91335cf1668f0af1347668636b3.svg";